import { render, staticRenderFns } from "./step2.vue?vue&type=template&id=500fb5fc&scoped=true"
import script from "./step2.vue?vue&type=script&lang=js"
export * from "./step2.vue?vue&type=script&lang=js"
import style0 from "./step2.vue?vue&type=style&index=0&id=500fb5fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "500fb5fc",
  null
  
)

export default component.exports